<template>
  <div class="pt-news-detail">
    <div class="pt-news-detail__inner">
      <!-- 加载中 -->
      <div v-if="loading" v-loading="loading" class="pt-news-detail__card">
        <div style="min-height:300px" />
      </div>

      <div v-else class="pt-news-detail__card">
        <!-- 0. 面包屑 -->
        <div class="pt-news-detail__crumb">
          <a @click="goHome">首页</a>
          <i>&gt;</i>
          <a @click="goChannel">{{ channelName }}</a>
          <i>&gt;</i>
          <span>正文</span>
        </div>

        <!-- 1. 顶部标题 -->
        <h2 class="pt-news-detail__title">{{ detail.title }}</h2>

        <!-- 2. 标题下面横线 -->
        <div class="pt-news-detail__divider" />

        <!-- 3. 发表时间 + 来源 -->
        <div class="pt-news-detail__meta">
          <span>发表时间：{{ detail.publishTime }}</span>
          <template v-if="detail.source || detail.fromSource">
            <span class="pt-news-detail__meta-sep">|</span>
            <span>来源：{{ detail.source || detail.fromSource }}</span>
          </template>
        </div>

        <!-- 4. 新闻详情 -->
        <div class="pt-news-detail__body" v-html="detail.content || detail.remarks || ''" />

        <!-- 5. 附件列表 -->
        <div v-if="attachments.length > 0" class="pt-news-detail__attach">
          <h4 class="pt-news-detail__attach-title">附件下载</h4>
          <ul class="pt-news-detail__attach-list">
            <li
              v-for="(file, i) in attachments"
              :key="i"
              class="pt-news-detail__attach-item"
            >
              <svg class="pt-news-detail__attach-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM6 20V4h5v6h6v10H6z" />
              </svg>
              <a class="pt-news-detail__attach-name" @click="downloadFile(file)">
                {{ file.remark || file.remark || '附件' + (i + 1) }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cmsNewsDetail } from '@/http/api/CmsApi'
import { FileDownload3 } from '@/http/api/FileApi'
import { getChannelConfig } from './portalData'

export default {
  name: 'PortalNewsDetail',
  data () {
    return {
      loading: false,
      detail: {},
      attachments: []
    }
  },
  computed: {
    articleId () {
      return this.$route.params.id || this.$route.query.id || ''
    },
    channelKey () {
      return this.$route.query.channel || ''
    },
    channelName () {
      var self = this
      // 优先从 query channel 参数获取（含 navChannels + hiddenChannels）
      if (self.channelKey) {
        var found = getChannelConfig(self.channelKey)
        if (found) return found.label
      }
      // 其次从 query cat 参数获取
      if (self.$route.query.cat) return self.$route.query.cat
      // 最后从 API 返回的详情数据获取
      var d = self.detail
      return d.className || d.categoryName || d.parentNames || '栏目'
    }
  },
  created () {
    this.loadDetail()
  },
  methods: {
    downloadFile: function (file) {
      FileDownload3(file.path, file.remark);
    },
    loadDetail: function () {
      var self = this
      var id = self.articleId
      if (!id) return

      self.loading = true
      cmsNewsDetail({ id: id }).then(function (res) {
        self.loading = false
        if (res.code === '000' || res.code === '1') {
          var data = res.result || {}
          self.detail = data
          // 附件列表
          var atts = data.attFileList || data.attFileList || data.attFileList || []
          self.attachments = Array.isArray(atts) ? atts : []
        }
      }).catch(function () {
        self.loading = false
      })
    },

    formatDate: function (str) {
      if (!str) return ''
      return String(str).substring(0, 10)
    },

    goHome: function () {
      this.$router.push('/portal')
    },

    goChannel: function () {
      if (this.channelKey) {
        this.$router.push('/portal/' + this.channelKey)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pt-news-detail {
  position: relative;
  z-index: 1;
  background: var(--pt-bg, #f4f6f9);
}
.pt-news-detail__inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 16px 12px 32px;
  min-height: 420px;
}
.pt-news-detail__loading {
  min-height: 300px;
}
.pt-news-detail__card {
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 6px;
  padding: 20px 16px 28px;
}

/* 0. 面包屑 */
.pt-news-detail__crumb {
  display: flex;
  margin-bottom: 16px;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
}
.pt-news-detail__crumb a {
  color: var(--pt-muted, #9ca3af);
  cursor: pointer;
}
.pt-news-detail__crumb a:hover {
  color: #0a447c;
}
.pt-news-detail__crumb i {
  margin: 0 6px;
  font-style: normal;
  color: #c0c4cc;
}

/* 1. 标题 */
.pt-news-detail__title {
  margin: 0 0 0 0;
  font-size: 22px;
  font-weight: 700;
  color: #1a1f2b;
  text-align: center;
  line-height: 2;
}

/* 2. 横线 */
.pt-news-detail__divider {
  margin: 16px auto;
  width: 100%;
  height: 1px;
  border-radius: 2px;
  background: #F2F3F7;
}

/* 3. 发表时间 + 来源 */
.pt-news-detail__meta {
  text-align: center;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
  margin-bottom: 24px;
}
.pt-news-detail__meta-sep {
  margin: 0 10px;
}

/* 4. 正文 */
.pt-news-detail__body {
  line-height: 1.9;
  color: #333;
  font-size: 15px;
  padding: 0 8px;
}
.pt-news-detail__body :deep(img) {
  max-width: 100%;
  height: auto;
}

/* 5. 附件 */
.pt-news-detail__attach {
  margin-top: 32px;
  padding: 20px 16px;
  border-top: 1px solid var(--pt-line-2, #e5e7eb);
  background: #f8fafc;
  border-radius: 4px;
}
.pt-news-detail__attach-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1f2b;
}
.pt-news-detail__attach-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pt-news-detail__attach-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.pt-news-detail__attach-icon {
  flex: none;
  width: 18px;
  height: 18px;
  fill: #0a447c;
}
.pt-news-detail__attach-name {
  color: #0a447c;
  font-size: 14px;
  cursor: pointer;
}
.pt-news-detail__attach-name:hover {
  text-decoration: underline;
}

/* ===== 响应式 ===== */
@media (min-width: 640px) {
  .pt-news-detail__inner {
    padding: 20px 16px 40px;
  }
  .pt-news-detail__card {
    padding: 26px 24px 32px;
  }
}

@media (min-width: 768px) {
  .pt-news-detail__inner {
    padding: 20px 16px 40px;
  }
  .pt-news-detail__card {
    padding: 30px 32px 40px;
  }
  .pt-news-detail__title {
    font-size: 24px;
  }
}

@media (min-width: 1024px) {
  .pt-news-detail__card {
    padding: 22px 30px 38px;
  }
}
</style>
